import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, ArrowRight, CheckCircle2, Zap, Headphones } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const navigate = useNavigate();

  const goToContact = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  return (
    <section className="relative bg-gradient-to-b from-blue-50/50 to-white py-12 lg:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 animate-fade-up">
            {/* Main Title */}
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight">
              <span className="text-gray-900">Installation &</span>
              <br />
              <span className="text-gray-900">Support Informatique</span>
              <br />
              <span className="text-blue-500">Professionnel</span>
            </h1>

            {/* Subtitle */}
            <p className="text-lg text-gray-600 max-w-xl leading-relaxed">
              PC, imprimantes, téléphonie IP et mise en réseau. Votre partenaire de confiance pour tous vos besoins informatiques professionnels.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-2">
              <Button 
                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg flex items-center gap-2 h-auto transition-all duration-200 shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40"
                onClick={goToContact}
              >
                <FileText className="w-5 h-5" />
                Demander un devis gratuit
              </Button>
              <Button 
                variant="outline"
                className="border-2 border-blue-500 text-blue-500 hover:bg-blue-50 font-semibold px-6 py-3 rounded-lg flex items-center gap-2 h-auto transition-all duration-200"
                onClick={() => {
                  const servicesSection = document.getElementById('services');
                  if (servicesSection) {
                    servicesSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Découvrir nos services
                <ArrowRight className="w-5 h-5" />
              </Button>
            </div>

            {/* Benefits */}
            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center gap-2 text-gray-700">
                <CheckCircle2 className="w-5 h-5 text-green-500" />
                <span className="font-medium">Installation rapide</span>
              </div>
              <div className="flex items-center gap-2 text-gray-700">
                <CheckCircle2 className="w-5 h-5 text-green-500" />
                <span className="font-medium">Support réactif</span>
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative animate-fade-up-delay">
            {/* Support Badge */}
            <div className="absolute -top-2 right-4 lg:right-8 z-10">
              <div className="bg-green-500 text-white px-4 py-2 rounded-full flex items-center gap-2 shadow-lg">
                <Headphones className="w-4 h-4" />
                <div className="text-sm">
                  <span className="font-semibold">Support 6j/7</span>
                  <br />
                  <span className="text-green-100 text-xs">Du lundi au samedi</span>
                </div>
              </div>
            </div>

            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/hero-office.jpg"
                alt="Bureau avec ordinateurs professionnels"
                className="w-full h-auto object-cover"
              />
              
              {/* Installation Badge */}
              <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-3 rounded-xl shadow-lg flex items-center gap-3">
                <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                  <Zap className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-xs text-gray-500">Installation</p>
                  <p className="font-semibold text-gray-900">Rapide & Efficace</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
